import WhatWeDo from './whatwedo'

export default WhatWeDo
